import { serverTimestamp } from 'firebase/firestore'
import {
  typedCollection,
  typedDoc,
  getDocument,
  getCollection,
  updateDocument,
  orderBy,
} from '@/lib/firebase/firestore'
import type { ServiceRequestDocument, RequestStatus } from '@/types'

const col = () => typedCollection<ServiceRequestDocument>('serviceRequests')

export const adminRequestsService = {
  async getAllRequests(): Promise<Array<ServiceRequestDocument & { id: string }>> {
    return getCollection(col(), orderBy('createdAt', 'desc'))
  },

  async getRequestById(id: string): Promise<(ServiceRequestDocument & { id: string }) | null> {
    const ref = typedDoc<ServiceRequestDocument>('serviceRequests', id)
    const data = await getDocument(ref)
    return data ? { ...data, id } : null
  },

  async updateStatus(id: string, status: RequestStatus): Promise<void> {
    const ref = typedDoc<ServiceRequestDocument>('serviceRequests', id)
    await updateDocument(ref, {
      status,
      updatedAt: serverTimestamp(),
    } as unknown as ServiceRequestDocument)
  },
}
